"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../slice/sliceReview/constants");
const selectors_1 = __importDefault(require("../../slice/selectors"));
const sliceReview_1 = require("../../slice/sliceReview");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const SearchUpdateTemplate_1 = __importDefault(require("./SearchUpdateTemplate"));
const OptionCreateReview = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./OptionCreateReview'))));
const ExistFile = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./ExistFileComponent'))));
const ConfirmCreateNewRound = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./ConfirmationModal'))));
const ReviewWebsite = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./ReviewWebsite'))));
const UploadNewAsset = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./UploadNewAsset'))));
const SaveAsTemplate = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./SaveAsTemplate'))));
const TemplateSettingsModal = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./TemplateSettingModal'))));
const SelectProjectComponent = () => {
    const { phase, project } = (0, react_redux_1.useSelector)(selectors_1.default);
    const [selectedProject, setSelectedProject] = (0, react_1.useState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch(selectedProject ? (0, sliceReview_1.selectProject)(selectedProject) : (0, sliceReview_1.disableNextBtn)());
    }, [selectedProject]);
    (0, react_1.useEffect)(() => {
        if (project && phase === constants_1.PHASE.startReview) {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
    }, [project]);
    const onChange = (value) => {
        if (value.projectId) {
            setSelectedProject(value.projectId);
        }
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-select'] },
        react_1.default.createElement(pulse_components_1.PulseProjectsSelect, { classes: {
                root: styles_modules_less_1.default['review-select__root'],
                label: styles_modules_less_1.default['review-select__label'],
                select: styles_modules_less_1.default['review-select__menuCtn'],
                placeholder: styles_modules_less_1.default['review-select__placeholder'],
                selectContainer: styles_modules_less_1.default['review-select__selectContainer'],
            }, extraParams: {
                filter: {
                    jobstatus: 'active',
                },
            }, isClearable: false, value: project, valueChangeHandler: onChange, labelName: "Select a project to associate with this review", placeholder: "Start typing to search for a project", insideModal: true })));
};
const CreateReviewContent = () => {
    const { phase } = (0, react_redux_1.useSelector)(selectors_1.default);
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") }, (() => {
        switch (phase) {
            case constants_1.PHASE.confirmCreateNewRound:
                return react_1.default.createElement(ConfirmCreateNewRound, null);
            case constants_1.PHASE.selectOption:
                return react_1.default.createElement(OptionCreateReview, null);
            case constants_1.PHASE.chooseExisting:
                return react_1.default.createElement(ExistFile, null);
            case constants_1.PHASE.chooseUrl:
                return react_1.default.createElement(ReviewWebsite, null);
            case constants_1.PHASE.chooseUpload:
                return react_1.default.createElement(UploadNewAsset, null);
            case constants_1.PHASE.savingTemplate:
                return react_1.default.createElement(SaveAsTemplate, null);
            case constants_1.PHASE.updateTemplate:
                return react_1.default.createElement(SearchUpdateTemplate_1.default, null);
            case constants_1.PHASE.templateSettings:
                return react_1.default.createElement(TemplateSettingsModal, null);
            default:
                return react_1.default.createElement(SelectProjectComponent, null);
        }
    })()));
};
exports.default = CreateReviewContent;
